import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import * as XLSX from "xlsx";
import {
  fetchWalletBalance,
  fetchLienBalance,
} from "../../../Store/Slices/WalletSlice";
import DynamicTable from "../../../ResuableCompoment/DynamicTable1";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";

/* ===== HELPER ===== */
const getToday = () => {
  const d = new Date();
  return d.toISOString().split("T")[0];
};

const CommissionRetailer = () => {
  const dispatch = useDispatch();
  const { username, merchant_account_no, userId } =
    useSelector((s) => s.auth.employeeDetails) || {};

  const [activeTab, setActiveTab] = useState("COMMISSION");

  const [totalElements, setTotalElements] = useState(0);

  /* ================= COMMISSION BALANCE ================= */
  const [commissionBalance, setCommissionBalance] = useState(0);

  const { callApi: commissionApi } = useApi(
    `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
    "GET"
  );

  const { callApi: transferCommissionToMain } = useApi(
    "/business/wallet/settle",
    "POST"
  );

  const { callApi: Commissionledgerreport } = useApi(
    "/ledger/commission",
    "GET"
  );

  /* ================= TABLE STATES ================= */
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 10;


  const [isExporting, setIsExporting] = useState(false);

 

  /* ================= EXCEL DOWNLOAD LOGIC ================= */
  // const downloadExcel = async () => {
  //   setIsExporting(true);

  //   let allData = [];
  //   let currentPage = 0;
  //   const excelSize = 1000;

  //   try {
  //     while (true) {
  //       // Fetch data using the existing states: username, fromDate, toDate
  //       let query = `?bid=${username}&page=${currentPage}&size=${excelSize}&fromDate=${fromDate}&toDate=${toDate}`;

  //       const res = await Commissionledgerreport(null, query);
  //       const pageData = (res?.content || []).filter(Boolean);

  //       allData = [...allData, ...pageData];

  //       if (currentPage + 1 >= (res?.totalPages || 0)) break;
  //       currentPage++;
  //     }

  //     if (allData.length === 0) {
  //       alert("No data found for the selected date range.");
  //       setIsExporting(false);
  //       return;
  //     }

  //     /* ================= FORMAT EXCEL ROWS ================= */
  //     const rows = allData.map(r => ({
  //       "Txn ID": r.txnId || "",
  //       "Date": getDisplayDate(r.txnDate),
  //       "Narration": r.narration || "",
  //       "Type": r.txnType || "",
  //       "Net Amount": r.txnAmount || "",
  //       "Commission": r.commission || "",
  //       "TDS": r.tds || "",
  //       "Balance": r.balance || "",
  //     }));

  //     const ws = XLSX.utils.json_to_sheet(rows);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Commission_Ledger");

  //     XLSX.writeFile(
  //       wb,
  //       `Commission_Ledger_${fromDate}_to_${toDate}.xlsx`
  //     );
  //   } catch (err) {
  //     console.error(err);
  //     alert("Excel download failed. Please try again.");
  //   } finally {
  //     setIsExporting(false);
  //   }
  // };

  /* ================= EXCEL DOWNLOAD LOGIC ================= */
  // const downloadExcel = async () => {
  //   setIsExporting(true);

  //   try {
  //     // 1. Quick fetch to find the EXACT total elements for this date range
  //     const countQuery = `?bid=${username}&page=0&size=1&fromDate=${fromDate}&toDate=${toDate}`;
  //     const countRes = await Commissionledgerreport(null, countQuery);
  //     const exactTotalElements = countRes?.totalElements || 0;

  //     if (exactTotalElements === 0) {
  //       alert("No data found for the selected date range.");
  //       setIsExporting(false);
  //       return;
  //     }

  //     // 2. Fetch everything at once using exactTotalElements
  //     const fullQuery = `?bid=${username}&page=0&size=${exactTotalElements}&fromDate=${fromDate}&toDate=${toDate}`;
  //     const fullRes = await Commissionledgerreport(null, fullQuery);
  //     const allData = (fullRes?.content || []).filter(Boolean);

  //     /* ================= FORMAT EXCEL ROWS ================= */
  //     const rows = allData.map(r => ({
  //       "Txn ID": r.txnId || "",
  //       "Date": getDisplayDate(r.txnDate),
  //       "Narration": r.narration || "",
  //       "Type": r.txnType || "",
  //       "Net Amount": r.txnAmount || "",
  //       "Commission": r.commission || "",
  //       "TDS": r.tds || "",
  //       "Balance": r.balance || "",
  //     }));

  //     const ws = XLSX.utils.json_to_sheet(rows);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Commission_Ledger");

  //     XLSX.writeFile(
  //       wb,
  //       `Commission_Ledger_${fromDate}_to_${toDate}.xlsx`
  //     );
  //   } catch (err) {
  //     console.error("Excel download error:", err);
  //     alert("Excel download failed. Please try again.");
  //   } finally {
  //     setIsExporting(false);
  //   }
  // };


  /* ================= EXCEL DOWNLOAD (DYNAMIC SIZE) ================= */
  const downloadExcel = async () => {
    setIsExporting(true);

    try {
      if (totalElements === 0) {
        alert("No data available to export.");
        setIsExporting(false);
        return;
      }

      // Fetch everything at once using totalElements dynamically directly from state
      const fullQuery = `?bid=${username}&page=0&size=${totalElements}&fromDate=${fromDate}&toDate=${toDate}`;
      const fullRes = await Commissionledgerreport(null, fullQuery);
      const allData = (fullRes?.content || []).filter(Boolean);

      /* ================= FORMAT EXCEL ROWS ================= */
      const rows = allData.map(r => ({
        "Txn ID": r.txnId || "",
        "Date": getDisplayDate(r.txnDate),
        "Narration": r.narration || "",
        "Type": r.txnType || "",
        "Net Amount": r.txnAmount || "",
        "Commission": r.commission || "",
        "TDS": r.tds || "",
        "Balance": r.balance || "",
      }));

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Commission_Ledger");

      XLSX.writeFile(
        wb,
        `Commission_Ledger_${fromDate}_to_${toDate}.xlsx`
      );
    } catch (err) {
      console.error("Excel download error:", err);
      alert("Excel download failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  /* ================= TRANSFER STATES ================= */
  const [transferCommissionAmount, setTransferCommissionAmount] = useState("");
  const [isLoadingCommission, setIsLoadingCommission] = useState(false);
  const [commissionMessage, setCommissionMessage] = useState("");

  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());

  /* ================= LOAD BALANCE ================= */
  useEffect(() => {
    loadCommissionBalance();
    fetchCommissionLedger();
  }, []);

  const loadCommissionBalance = async () => {
    const res = await commissionApi();
    setCommissionBalance(res?.balance || 0);
  };

  /* ================= FETCH LEDGER ================= */
  const fetchCommissionLedger = async (targetPage = 0, loadMore = false) => {
    setLoading(true);
    try {
      const query = `?bid=${username}&page=${targetPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}`;

      const res = await Commissionledgerreport(null, query);
      const data = (res?.content || []).filter(Boolean);

      setTotalPages(res?.totalPages || 0);
      setTotalElements(res?.totalElements || 0);

      setHistory((prev) =>
        loadMore ? [...prev, ...data] : data
      );

      setPage(targetPage);
      setIsSearched(true);
    } catch (err) {
      console.error(err);
      if (!loadMore) setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOAD MORE ================= */
  // const handleLoadMore = () => {
  //   if (page + 1 < totalPages) {
  //     fetchCommissionLedger(page + 1, true);
  //   }
  // };

  /* ================= PAGINATION ACTIONS ================= */
  // 🔥 1. Handle Prev/Next and Page Number clicks
  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      fetchCommissionLedger(newPage, false); // false = replace data
      
      // Optional: Scroll to top of table when page changes
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // 🔥 2. Helper to generate page numbers with ellipses
  const getPaginationPages = (current, total) => {
    if (total <= 1) return [];
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages = [];
    const delta = 2;
    let prev = null;
    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current + 1 - delta && i <= current + 1 + delta)) {
        if (prev !== null && i - prev > 1) pages.push("...");
        pages.push(i);
        prev = i;
      }
    }
    return pages;
  };

  /* ================= TRANSFER ================= */
  const handleCommissionToMainTransfer = async () => {
    if (!transferCommissionAmount || transferCommissionAmount <= 0) {
      setCommissionMessage("Please enter a valid amount.");
      return;
    }

    setIsLoadingCommission(true);
    setCommissionMessage("");

    try {
      const res = await transferCommissionToMain(
        null,
        `?amount=${parseFloat(transferCommissionAmount)}&userId=${userId}`
      );

      if (res.status === "SUCCESS") {
        setCommissionMessage(
          "Commission transferred successfully."
        );

        dispatch(fetchWalletBalance());
        dispatch(fetchLienBalance());

        await loadCommissionBalance();
      } else {
        setCommissionMessage(res.message || "Transfer failed.");
      }
    } catch (err) {
      setCommissionMessage("Error transferring commission.");
    } finally {
      setIsLoadingCommission(false);
      setTransferCommissionAmount("");

      setTimeout(() => setCommissionMessage(""), 2000);
    }
  };

  /* ================= TOTALS ================= */

  const totalNetAmount = history.reduce(
    (sum, tx) => sum + Number(tx?.netAmount || 0),
    0
  );

  const totalTds = history.reduce(
    (sum, tx) => sum + Number(tx?.tds || 0),
    0
  );


  const totalCommission = history.reduce(
    (sum, tx) => sum + Number(tx?.commission || 0),
    0
  );

  const columns = [
    { key: "txnId", label: "Txn ID" },
    {
      key: "txnDate",
      label: "Date",
      render: (v) => getDisplayDate(v),
    },
    {
      key: "narration",
      label: "Narration",
      render: (v) => (
        <span className="text-indigo-700 font-medium">
          {v || "—"}
        </span>
      ),
    },

    {
      key: "commission",
      label: "Comm",
      render: (v) => (
        <span className="font-bold text-green-800">
          ₹{Number(v || 0)?.toFixed(2)}
        </span>
      ),
    },

    {
      key: "tds",
      label: "TDS",
      render: (v) => (
        <span className="font-semibold text-red-800">
          ₹{Number(v || 0)?.toFixed(2)}
        </span>
      ),
    },
    {
      key: "txnAmount",
      label: "Net Amount",
      render: (v, row) => {
        const value = Number(v || 0);
        if (!value) return <span className="text-gray-400">—</span>;

        if (row.txnType === "CREDIT" || row.txnType === "Approved")
          return (
            <span className="font-semibold text-green-700">
              ₹{value?.toFixed(2)}
            </span>
          );

        if (row.txnType === "DEBIT")
          return (
            <span className="font-semibold text-red-600">
              ₹{value?.toFixed(2)}
            </span>
          );

        if (row.txnType === "REFUND")
          return (
            <span className="font-semibold text-yellow-700 bg-yellow-50 px-2 py-0.5 rounded">
              ₹{value?.toFixed(2)}
            </span>
          );

        return <span className="text-gray-400">—</span>;
      },
    },
    {
      key: "balance",
      label: "Balance",
      render: (v) => (
        <span className="font-semibold text-blue-900">
          ₹{Number(v || 0)?.toFixed(2)}
        </span>
      ),
    },
  ];

   // 🔥 NEW STATE: Tracks if a search has been completed
  const [isSearched, setIsSearched] = useState(false);

  // If the user changes any filters, hide the export button until they search again
  useEffect(() => {
    setIsSearched(false);
  }, [fromDate, toDate]);

  /* ================= UI ================= */
  return (
    <div className="min-h-screen bg-[#EEF1F5] p-4 sm:p-6">

      {/* HEADER */}
      <h1 className="text-2xl font-bold mb-6">Commission Section</h1>

      {/* TABS */}
      <div className="flex mb-6 rounded-xl overflow-hidden shadow">
        <button
          onClick={() => setActiveTab("COMMISSION")}
          className={`flex-1 py-3 ${activeTab === "COMMISSION"
            ? "bg-[#0A2A4F] text-white"
            : "bg-white"
            }`}
        >
          Report
        </button>

        <button
          onClick={() => setActiveTab("TRANSFER")}
          className={`flex-1 py-3 ${activeTab === "TRANSFER"
            ? "bg-amber-600 text-white"
            : "bg-white"
            }`}
        >
          Transfer
        </button>
      </div>

      <div className="bg-white p-6 rounded-xl shadow">

        {activeTab === "COMMISSION" && (
          <>
            {/* FILTER */}
            {/* <div className="flex gap-3 mb-4">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="border px-2 py-1 rounded"
              />

              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="border px-2 py-1 rounded"
              />

              <button
                onClick={() => fetchCommissionLedger(0)}
                className="bg-blue-900 text-white px-4 rounded"
              >
                Search
              </button>

              <button
                onClick={downloadExcel}
                disabled={isExporting}
                className="bg-green-700 hover:bg-green-800 text-white px-4 py-1 rounded shadow disabled:opacity-70 flex items-center gap-2"
              >
                {isExporting ? "Preparing Excel..." : "Export Excel"}
              </button>
            </div> */}
            {/* FILTER */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 mb-6">
              
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full sm:w-auto border px-3 py-2 rounded focus:outline-none focus:border-blue-900"
              />

              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full sm:w-auto border px-3 py-2 rounded focus:outline-none focus:border-blue-900"
              />

              {/* Wrapper for buttons to sit side-by-side on mobile, or inline on desktop */}
              <div className="flex flex-row gap-3 w-full sm:w-auto">
                <button
                  onClick={() => fetchCommissionLedger(0)}
                  className="flex-1 sm:flex-none bg-blue-900 hover:bg-blue-950 text-white px-6 py-2 rounded shadow transition-colors"
                >
                  Search
                </button>

                {/* <button
                  onClick={downloadExcel}
                  disabled={isExporting}
                  className="flex-1 sm:flex-none bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded shadow disabled:opacity-70 flex items-center justify-center gap-2 transition-colors"
                >
                  {isExporting ? "Preparing..." : "Export Excel"}
                </button> */}
                {/* ===== EXPORT (ONLY VISIBLE IF SEARCHED & DATA EXISTS) ===== */}
                {isSearched && totalElements > 0 && (
                  <button
                    onClick={downloadExcel}
                    disabled={isExporting}
                    className="flex-1 sm:flex-none bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded shadow disabled:opacity-70 flex items-center justify-center gap-2 transition-colors"
                  >
                    {isExporting ? "Preparing..." : "Export Excel"}
                  </button>
                )}
              </div>

            </div>

            {/* TABLE */}
            <DynamicTable
              columns={columns}
              data={history}
              isLoading={loading}
              rowClassName={(row) => {
                if (row.txnType === "DEBIT" || row.txnType === "REVERSED") {
                  return "bg-red-100"; // 🔴 Darker Debit
                }

                if (row.txnType === "REFUND") {
                  return "bg-yellow-100"; // 🟡 Darker Refund
                }

                if (
                  row.txnType === "CREDIT" ||
                  row.txnType === "APPROVED"
                ) {
                  return "bg-green-100"; // 🟢 Darker Credit
                }

                if (row.txnType === "REJECTED") {
                  return "bg-red-200 border-l-4 border-red-600"; // 🔴 More strong rejected
                }

                return "";
              }}
              footerTotals={{
                totalNetAmount,
                totalTds,
                totalCommission,
              }}
            />

            {/* LOAD MORE */}
            {/* {page + 1 < totalPages && (
              <div className="text-center mt-4">
                <button
                  onClick={handleLoadMore}
                  className="px-5 py-2 bg-[#0A2A4F] text-white rounded"
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            )} */}
            {/* ================= PAGINATION SYSTEM ================= */}
            {totalPages > 1 && (
                <div className="flex flex-wrap items-center justify-center gap-2 pt-6 pb-2">
                    
                    {/* Previous Button */}
                    <button
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 0 || loading}
                        className="h-10 px-4 rounded-xl border border-slate-200 bg-white text-slate-600 font-semibold text-xs transition hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                    >
                        Previous
                    </button>

                    {/* Page Numbers */}
                    <div className="flex items-center gap-1.5 hidden sm:flex">
                        {getPaginationPages(page, totalPages).map((p, i) =>
                            p === "..." ? (
                                <span key={`ellipsis-${i}`} className="w-8 text-center text-slate-400 font-medium">...</span>
                            ) : (
                                <button
                                    key={p}
                                    onClick={() => handlePageChange(p - 1)}
                                    disabled={loading}
                                    className={`h-10 min-w-[40px] px-2 rounded-xl border text-xs font-bold transition flex items-center justify-center
                                        ${page === p - 1
                                            ? "bg-[#0A2A4F] text-white border-[#0A2A4F] shadow-md"
                                            : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:text-slate-900"
                                        }`}
                                >
                                    {p}
                                </button>
                            )
                        )}
                    </div>

                    {/* Next Button */}
                    <button
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page + 1 >= totalPages || loading}
                        className="h-10 px-4 rounded-xl border border-slate-200 bg-white text-slate-600 font-semibold text-xs transition hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                    >
                        Next
                    </button>

                </div>
            )}
          </>
        )}

        {activeTab === "TRANSFER" && (
          <div className="max-w-md">
            <p className="mb-2 font-semibold">
              Balance: ₹{commissionBalance}
            </p>

            <input
              type="number"
              value={transferCommissionAmount}
              onChange={(e) =>
                setTransferCommissionAmount(e.target.value)
              }
              className="w-full border p-2 mb-3 rounded"
              placeholder="Enter amount"
            />

            <button
              onClick={handleCommissionToMainTransfer}
              className="w-full bg-amber-600 text-white py-2 rounded"
            >
              {isLoadingCommission ? "Processing..." : "Transfer"}
            </button>

            {commissionMessage && (
              <p className="mt-2 text-blue-600">
                {commissionMessage}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CommissionRetailer;
